import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import Dashboard from './components/Dashboard';
import RequireAuth from './components/RequireAuth';
import Acente_Layout from './components/agency/Acente_Layout';
import Driver_Login from './components/driver/Driver_Login';
import Driver_Home from './components/driver/Driver_Home';
import { ToastProvider } from './hooks/useToast';
import { NotificationProvider } from './components/ui/NotificationModal';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // LocalStorage'dan kullanıcı bilgilerini kontrol et
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    const userRole = localStorage.getItem('role');

    if (token && userData && userRole) {
      try {
        const parsedUser = JSON.parse(userData);
        setUser({
          ...parsedUser,
          role: userRole,
          token: token
        });
      } catch (error) {
        console.error('Kullanıcı verileri parse edilemedi:', error);
        localStorage.clear();
      }
    }
    setLoading(false);

    // Auth logout event listener - axios interceptor'dan gelen logout sinyali
    const handleAuthLogout = () => {
      setUser(null);
      // Mevcut sayfada kalmak için sadece state'i temizle, yönlendirme yapma
    };

    window.addEventListener('auth-logout', handleAuthLogout);
    
    // Cleanup
    return () => {
      window.removeEventListener('auth-logout', handleAuthLogout);
    };
  }, []);

  const handleLoginSuccess = (userData) => {
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.clear();
    setUser(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-bht-red mx-auto"></div>
          <p className="mt-4 text-gray-600">Yükleniyor...</p>
        </div>
      </div>
    );
  }

  return (
    <ToastProvider>
      <NotificationProvider>
        <Router>
          <div className="App">
            <Routes>
          <Route 
            path="/login" 
            element={
              user ? <Navigate to={
                user.role === 'AGENCY' ? "/agency" : 
                user.role === 'DRIVER' ? "/driver" : 
                "/dashboard"
              } replace /> : 
              <LoginPage onLoginSuccess={handleLoginSuccess} />
            } 
          />
          
          {/* Şoför Login */}
          <Route 
            path="/driver/login" 
            element={
              user ? <Navigate to="/driver" replace /> : 
              <Driver_Login onLoginSuccess={handleLoginSuccess} />
            } 
          />
          
          {/* Admin Dashboard */}
          <Route 
            path="/dashboard" 
            element={
              <RequireAuth user={user} allowedRoles={['ADMIN']}>
                <Dashboard user={user} onLogout={handleLogout} />
              </RequireAuth>
            } 
          />
          
          {/* Acente Portal */}
          <Route 
            path="/agency/*" 
            element={
              <RequireAuth user={user} allowedRoles={['AGENCY']}>
                <Acente_Layout user={user} onLogout={handleLogout} />
              </RequireAuth>
            } 
          />
          
          {/* Şoför Portal */}
          <Route 
            path="/driver" 
            element={
              <RequireAuth user={user} allowedRoles={['DRIVER']}>
                <Driver_Home user={user} onLogout={handleLogout} />
              </RequireAuth>
            } 
          />
          
          <Route 
            path="/" 
            element={<Navigate to={
              user ? 
                (user.role === 'AGENCY' ? "/agency" : 
                 user.role === 'DRIVER' ? "/driver" : 
                 "/dashboard") : 
                "/login"
            } replace />} 
          />
            </Routes>
          </div>
        </Router>
      </NotificationProvider>
    </ToastProvider>
  );
}

export default App;
